export const SUCCESS_AUTH_TEXT = 'congratulations you signed in'
